import React from 'react';

const Highlight = () => {
    return (
        <section class="highlight py-5">
  <div class="container">
    <div class="row text-left">
      <div class="col-md-4 m-auto col-lg-4">
        <div class="fdb-box fdb-touch">
          <img className='img-fluid' src="https://i.ibb.co/SQ3HFgv/highlight-1.jpg" alt="" />
        </div>
      </div>
      <div class="col-md-4 m-auto col-lg-4">
      <div class="fdb-box fdb-touch">
          <img className='img-fluid' src="https://i.ibb.co/vxt0zMR/highlight-2.jpg" alt="" />
        </div>
      </div>
      <div class="col-md-4 m-auto col-lg-4">
      <div class="fdb-box fdb-touch">
          <img className='img-fluid' src="https://i.ibb.co/Qb5F9gJ/highlight-3.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</section>
    );
};

export default Highlight;